<template>
  <v-container>
    <v-card class="mx-auto" max-width="400">
      <v-img src="/img/donaciones/hands.jpg" height="300px"></v-img>
      <v-card-title>Donaciones</v-card-title>
      <v-card-text>
        Número de cuenta en Banrural: 3556028255 a nombre de "Asociación Voz de la Esperanza"
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
